export default "__VITE_ASSET__40dc2ea7__"